export const REFERRAL_SEARCH_FIELDS = [
  "potential_customer.name",
  "potential_customer.phone_number",
  "potential_customer.email",
  "advocate.name",
  "advocate.phone_number",
  "advocate.email",
  "service_needed",
  "additional_info",
  "status",
  "address.line_one",
  "address.line_two",
  "address.city",
  "address.state",
  "address.zip_code",
];
